<template>
  <div class="courselist_box">
    <div class="courselist_header">
      <div style="position: relative">
        <a-select
          default-value="全部学校"
          style="width: 200px; margin-right: 30px"
          v-model="schoolCode"
          @change="reGetCourseList"
          showSearch
          optionFilterProp="children"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value="">全部学校</a-select-option>
          <a-select-option v-for="item in schoolList" :key="item.id" :value="item.id">
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
        <a-select
          default-value="-1"
          style="width: 100px; margin-right: 30px"
          v-model="status"
          @change="reGetCourseList"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value="">状态</a-select-option>
          <a-select-option value="0">未开始</a-select-option>
          <a-select-option value="1">进行中</a-select-option>
          <a-select-option value="2">已结束</a-select-option>
        </a-select>
        <a-select
          default-value="-1"
          style="width: 100px; margin-right: 30px"
          v-model="courseType"
          @change="reGetCourseList"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value="">课程保障</a-select-option>
          <a-select-option value="1">需要</a-select-option>
          <a-select-option value="0">不需要</a-select-option>
        </a-select>
        <a-select
          default-value=""
          style="width: 150px; margin-right: 30px"
          v-model="term"
          @change="reGetCourseList"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value="">全部学期</a-select-option>
          <a-select-option v-for="item in termInfo" :key="item.value" :value="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div>
        <a-button
          type="primary"
          style="margin-right: 30px"
          class="add_course_btn ZHIHUISHU_QZMD"
          @click="toggleCreateCourseModal(true)"
        >
          <a-icon type="plus-circle" theme="filled" />
          创建课程（周期）
        </a-button>
        <a-button type="primary" style="margin-right: 30px" class="export_out_btn ZHIHUISHU_QZMD" @click="downloadList">
          <a-icon type="download" />
          导出
        </a-button>
        <a-input-search
          v-model="courseName"
          placeholder="搜索课程名称"
          style="width: 240px"
          @search="reGetCourseList"
        />
      </div>
    </div>
    <div class="count_box">
      <div>
        课程数：
        <span>{{ totalCount || 0 }}</span>
      </div>
      <div>
        课节数：
        <span>{{ ext || 0 }}</span>
      </div>
    </div>
    <div class="classroom-manage">
      <a-table
        :columns="columns"
        :data-source="courseList"
        :pagination="false"
        :customRow="handleRowEvent"
        :row-key="(record, index) => record.id"
        :loading="tabLoading"
      >
        <template slot="statusDesc" slot-scope="text, record">
          <a-tag :color="record.status | filterCourseListStatusTag">{{ text }}</a-tag>
        </template>
        <template slot="courseName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="courseType" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="progress" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''" v-if="record.status == '2'">{{ text }}</span>
          <div v-else>
            <span class="count_box_color">{{ text.split('/')[0] || '' }}</span>
            <span>{{ text.split('/')[1] ? '/' + text.split('/')[1] : '' }}</span>
          </div>
        </template>
        <template slot="startTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="endTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="className" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="termName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="teacherName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="createdTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">删除</template>
            <img
              @click.prevent.stop="showDeleteConfirm(record)"
              style="width: 20px; height: 20px; cursor: pointer"
              src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/b2b0fcd1a994443dbb8f1a1c05a34b04.png"
              alt=""
            />
          </a-tooltip>
        </template>
      </a-table>
      <a-row type="flex" justify="end" style="margin-top: 16px; padding-bottom: 32px; padding-right: 16px">
        <a-pagination
          show-size-changer
          :default-current="1"
          :page-size-options="pageSizeOptions"
          :total="totalCount"
          :defaultPageSize="50"
          @change="handlePageChange"
          @showSizeChange="onShowSizeChange"
          v-model="pageNum"
          :pageSize.sync="pageSize"
          :show-total="(total) => `共 ${total} 条`"
          style="position: relative"
        />
      </a-row>
    </div>
    <class-modal :showModalProp.sync="showModal" @refresh="getCourseList"></class-modal>
    <create-course-modal
      :termList="termInfo"
      :schoolList="schoolList"
      :showModal="showCreateCourseModal"
      @refresh="getCourseList"
      @close="toggleCreateCourseModal"
    ></create-course-modal>
    <!-- delete: -->
    <!-- <my-dialog
      @hideMask="dialogFlagForDelete = false"
      :dialogFlag="dialogFlagForDelete"
      width="330px"
      p_lr="0"
    >
      <div class="dialog_inner_container_for_delete">
        <div class="dialog_inner_container_for_delete_header">提示</div>
        <div class="dialog_inner_container_for_delete_body">
          课程删除后无法恢复，请谨慎操作
        </div>
        <div class="dialog_inner_container_for_delete_footer">
          <div
            :class="[
              'dialog_inner_container_for_delete_footer_inner_item',
              'ZHIHUISHU_QZMD',
              index === 1 ? 'm_l15' : '',
            ]"
            v-for="(item, index) in deleteOperationList"
            :key="item.title"
            :style="{
              backgroundColor: item.bgc,
              border: item.border,
              color: item.color,
            }"
            @click="deleteOperationItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForDelete">
          <a-spin />
        </div>
      </div>
    </my-dialog> -->
    <DeleteDialog
      :showDelDialogProp.sync="dialogFlagForDelete"
      delTitle="删除课程"
      tipText="确认要删除此课程吗？"
      @handleDel="handleDel"
    />
  </div>
</template>

<script>
const columns = [
  {
    title: '状态',
    width: 90,
    dataIndex: 'statusDesc',
    scopedSlots: { customRender: 'statusDesc' }
  },
  {
    title: '课程名称',
    // align: 'center',
    dataIndex: 'courseName',
    scopedSlots: { customRender: 'courseName' }
  },
  {
    title: '课程保障',
    width: 88,
    minWidth: 88,
    dataIndex: 'courseType',
    scopedSlots: { customRender: 'courseType' }
  },
  {
    title: '课程进度',
    width: 88,
    minWidth: 88,
    dataIndex: 'progress',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '开始时间',
    width: 145,
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    width: 145,
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '主讲学校-教室',
    // align: 'center',
    dataIndex: 'className',
    scopedSlots: { customRender: 'className' }
  },
  {
    title: '学期',
    width: 90,
    dataIndex: 'termName',
    scopedSlots: { customRender: 'termName' }
  },
  {
    title: '主讲老师',
    width: 90,
    dataIndex: 'teacherName',
    scopedSlots: { customRender: 'teacherName' }
  },
  {
    title: '课程专员',
    width: 145,
    dataIndex: 'commissioner',
    scopedSlots: { customRender: 'createdTime' }
  },
  {
    title: '操作',
    align: 'right',
    dataIndex: 'action',
    width: '60px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    'my-dialog': () => import('../../components/my_dialog'),
    'class-modal': () => import('../../components/classModal/indexCourse'),
    'create-course-modal': () => import('./comp/createCourse/CreateCourseModal'),
    DeleteDialog: () => import('@/views/BasicData/BuildingManagement/components/delDailog.vue')
  },
  data() {
    return {
      showModal: false,
      showCreateCourseModal: false,
      schoolCode: '',
      status: '',
      courseType: '',
      courseName: '',
      schoolList: [],
      courseList: [],
      pageNum: 1,
      pageSize: 50,
      totalCount: 0,
      ext: 0,
      columns,
      handleRowEvent: (record, index) => ({
        on: {
          click: () => {
            this.$router.push({
              name: 'CourseListDetail',
              query: {
                id: record.id
              }
            })
            //点击行要做的操作
          }
        }
      }),
      tabLoading: false,
      dialogFlagForDelete: false,
      dialogLoadingForDelete: false,
      deleteOperationList: [
        {
          title: '确定删除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0
        },
        {
          title: '取消删除',
          bgc: '#2090FF',
          border: 'none',
          color: '#FFF',
          type: 1
        }
      ],
      deleteData: {},
      termInfo: [],
      term: '',
      pageSizeOptions: ['50', '100', '150', '200']
    }
  },
  filters: {
    filterCourseListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '0':
          res = 'blue'
          break
        case '1':
          res = 'green'
          break
        case '2':
          res = 'orange'
          break
      }
      return res
    }
  },
  created() {
    let dom = document.getElementsByClassName('ant-layout-content')[0] || {}
    dom.scrollTop = 0
    this.getSchoolList()
    this.getSchoolList()
    // this.getCourseList()
  },
  activated() {
    this.getCourseList()
    this.getTermList()
  },
  methods: {
    toggleCreateCourseModal(bl) {
      this.showCreateCourseModal = bl
    },
    async getTermList() {
      let termRes = await this.$http.getTermInfo()
      if (termRes.code !== 200) {
        return this.$message.warning('获取学期失败!')
      }
      this.termInfo = Object.keys(termRes.rt)
        .map((item) => {
          return {
            value: item,
            name: termRes.rt[item]
          }
        })
        .reverse()
    },
    /**
     * @description: 导出课程列表
     * @param {*}
     * @return {*}
     */
    async downloadList() {
      let school = this.schoolList.find((item) => item.id == this.schoolCode)
      let data = await this.$http.exportCourseList({
        schoolCode: school?.schoolId,
        status: this.status,
        courseType: this.courseType,
        courseName: this.courseName
      })
      if (data?.rt?.resultStatus == -1) {
        return this.$message.warning('导出发生错误!')
      }
      const blob = new Blob([data], {
        type: 'application/vnd.ms-excel'
      })
      const objectUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = '课程列表.xlsx'
      a.click()
      document.body.removeChild(a)
    },
    handlePageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getCourseList()
    },
    onShowSizeChange(current, size) {
      this.pageNum = current
      this.pageSize = size
      this.getCourseList()
    },
    reGetCourseList() {
      this.pageNum = 1
      this.getCourseList()
    },
    async getCourseList() {
      this.tabLoading = true
      let school = this.schoolList.find((item) => item.id == this.schoolCode)
      let res = await this.$http.getCourseList({
        schoolCode: school?.schoolId,
        status: this.status,
        courseType: this.courseType,
        courseName: this.courseName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        termId: this.term
      })
      this.tabLoading = false
      if (res.code !== 200) {
        this.$message.error(res.msg || '请求课程列表失败！')
        return
      }
      this.courseList = res.rt.list
      this.totalCount = res.rt.totalCount
      this.ext = res.rt.ext
    },
    async getSchoolList() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolList = schoolRes.rt
        }
      } catch (error) {
        // this.$message.error(error)
      }
    },
    // delete：
    async deleteOperationItemClick({ type }) {
      switch (type) {
        case 0:
          try {
            this.dialogLoadingForDelete = true
            let result = await this.$http.deleteCourse({
              courseId: this.deleteData.id
            })
            this.dialogLoadingForDelete = false
            if (result.code !== 200) return this.$message.error(result.msg)
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1)
              return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
            this.$message.success('删除成功')
            this.dialogFlagForDelete = false
            this.getCourseList()
          } catch (err) {
            console.log(err)
          }
          break
        case 1:
          this.dialogFlagForDelete = false
          break
      }
    },
    showDeleteConfirm(data) {
      this.dialogFlagForDelete = true
      this.deleteData = data
    },
    async handleDel() {
      try {
        // this.dialogLoadingForDelete = true
        let result = await this.$http.deleteCourse({
          courseId: this.deleteData.id
        })
        // this.dialogLoadingForDelete = false
        if (result.code !== 200) return this.$message.error(result.msg)
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
        this.$message.success('删除成功')
        this.dialogFlagForDelete = false
        this.getCourseList()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}
.courselist_box {
  ::v-deep.add_course_btn {
    padding: 0 10px;
    background-color: #5f60d3;
    border-color: #5f60d3;
  }
  ::v-deep.export_out_btn {
    background-color: #5f60d3;
    border-color: #5f60d3;
  }
  min-width: 1280px;
  .courselist_header {
    background-color: #fff;
    box-shadow: 0 0 10px #ddd;
    padding: 25px 25px 9px;
    display: flex;
    justify-content: space-between;
    > div:nth-child(1) {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      > div {
        margin-bottom: 16px;
      }
    }
    > div:nth-child(2) {
    }
  }
  ::v-deep {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      border-bottom: 0;
    }
    .ant-table-thead > tr > th {
      background: #f6f6f6;
    }
    .ant-table-tbody {
      tr:nth-child(even) {
        background: #f4f7fa;
      }
      .ant-table-row {
        cursor: pointer;
      }
    }
    .action {
      text-align: center;
      .action-icon {
        cursor: pointer;
      }
    }
    .ant-table-pagination {
      float: none;
      text-align: center;
    }
  }
  .end_gray {
    color: #bfbfbf;
  }
  .count_box {
    height: 60px;
    line-height: 60px;
    display: flex;
    > div {
      margin-right: 15px;
      > span {
        color: #5f60d3;
        font-weight: bold;
      }
    }
  }
  .count_box_color {
    color: #1a90ff;
    font-weight: bold;
    font-size: 16px;
  }
  .classroom-manage {
    min-height: 996px;
    text-align: left;
    background: #fff;
    box-shadow: 0 0 10px #ddd;
    border-radius: 10px;
  }
  // delete:
  .dialog_inner_container_for_delete {
    .dialog_inner_container_for_delete_header {
      @include dialogTitle(#222);
    }
    .dialog_inner_container_for_delete_body {
      padding: 15px;
      text-align: center;
    }
    .dialog_inner_container_for_delete_footer {
      width: 100%;
      height: 70px;
      padding-bottom: 23px;
      @include verticalAndCrosswiseCenter();
      .dialog_inner_container_for_delete_footer_inner_item {
        width: 74px;
        height: 32px;
        @include verticalAndCrosswiseCenter();
        font-size: 12px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        box-shadow: 0 0 5px #f5f5f5;
        transition: all 0.5s;
        letter-spacing: 1px;
        &:nth-of-type(1) {
          &:hover {
            border: 1px solid #2090ff !important;
            color: #2090ff !important;
          }
        }
        &:nth-of-type(2) {
          &:hover {
            background-color: #48a2fc;
          }
        }
      }
    }
  }
}
</style>
